// extracted by mini-css-extract-plugin
export var authorPhoto = "QuoteWithButtons-module--author-photo--c7184";
export var container = "QuoteWithButtons-module--container--ba3f3";
export var content = "QuoteWithButtons-module--content--5b02d";
export var description = "QuoteWithButtons-module--description--f1f64";
export var lowDimension = "QuoteWithButtons-module--low-dimension--d4bee";
export var mediumDimension = "QuoteWithButtons-module--medium-dimension--c79f4";
export var position = "QuoteWithButtons-module--position--887b4";
export var root = "QuoteWithButtons-module--root--931f1";